export default __webpack_public_path__ + "static/media/book-loader.c01a2c54.gif";